module.exports = __webpack_public_path__ + "static/feature-labor-cost-e31afc526f74fabb7cb07aa9aa0223d9.png";